import cn from 'classnames';
import { useState } from 'react';
import { useProducts } from '@features/cart/products/model';
import { Logo } from '@features/common';
import { ButtonCart, ButtonLogin, MobileLinks } from '@features/header';
import { ButtonSupport } from '@features/support';
import { Close, OpenMobileMenuIcon } from '@shared/assets/index.ts';
import { useUser } from '@shared/hooks';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import * as st from './styles.module.scss';

type Props = {
  Center: JSX.Element;
  transformHeader: string;
  menuClassName?: string;
  isHiddenHamburger?: boolean;
};

export const HeaderMobile: React.FC<Props> = ({
  Center,
  transformHeader,
  menuClassName = '',
  isHiddenHamburger,
}) => {
  const { isAuth } = useUser();

  const products = useProducts();

  const { module } = useModuleByCodeParam();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggle = () => {
    setIsDropdownOpen((p) => !p);
    document.body.style.overflow = isDropdownOpen ? 'unset' : 'hidden';

    document.getElementById('nav-bar')
      ? (document.getElementById('nav-bar')!.style.display = isDropdownOpen ? '' : 'none')
      : null;
  };

  return (
    <header
      className={st.header}
      style={{
        transform: isDropdownOpen ? 'translateY(0)' : `${transformHeader}`,
        transition: 'transform 0.5s ease-in-out',
      }}
    >
      <div
        className={st.wrapper}
        style={{
          opacity: transformHeader !== 'translateY(0)' && !isDropdownOpen ? '0' : '1',
          transition: '1s  ease-in-out',
          visibility: transformHeader !== 'translateY(0)' && !isDropdownOpen ? 'hidden' : 'visible',
        }}
      >
        <div className={st.wrapper__left}>
          {isHiddenHamburger ? null : (
            <div
              id="burger-button"
              className={cn(menuClassName, st.burgerBtn, isDropdownOpen ? st.open : '')}
              onClick={toggle}
            >
              {isDropdownOpen ? <Close className={st.closeMenuButton} /> : <OpenMobileMenuIcon />}
            </div>
          )}
          {/*<button*/}
          {/*   id="burger-button"*/}
          {/*   type="button"*/}
          {/*   className={cn(menuClassName, st.burgerBtn, isDropdownOpen ? st.open : '')}*/}
          {/*   onClick={toggle}*/}
          {/* >*/}
          {/*   <span></span>*/}
          {/*   <span></span>*/}
          {/*   <span></span>*/}
          {/* </button>*/}
        </div>

        <div className={st.wrapper__center}>{isDropdownOpen ? <Logo /> : Center}</div>
        <div className={st.wrapper__right}>
          {/* {isAuth && <ButtonMessenger />} */}
          {/* {isAuth && <ButtonNotifications />} */}
          {!isAuth && <ButtonSupport />}
          {isAuth &&
            module?.module_type === 'shop' &&
            products.items &&
            products.items.length > 0 && <ButtonCart />}
          {!isAuth && <ButtonLogin />}
        </div>
      </div>

      {isDropdownOpen && (
        <div className={st.list} onClick={toggle}>
          <div className={st.mobile__nav}>
            <MobileLinks />
          </div>
        </div>
      )}
    </header>
  );
};
